import React, { useState } from "react";
import SearchInputProps from "./SearchInputProps.type";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';

import styled from "@emotion/styled";

const SearchBox = styled.div({
  border: "none",
  backgroundColor: "#D0D0D0",
  position: "relative",
  borderRadius: "999px",
  paddingLeft: "20px",
  paddingRight: "20px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  maxWidth: "260px",
});

const SearchBoxInput = styled.input({
  marginLeft: "20px",
  marginRight: "20px",
  width: "90%",
  border: "none",
  backgroundColor: "#D0D0D0",
  height: "90%",
  ":focus": {
    outline: "none",
  },
});

const SearchBoxIcon = styled(SearchIcon)({
  position: "absolute",
  left: "5px",
  top: "5px",
  height: "22px",
  zIndex: 2,
});

const CancelIcon = styled(CloseIcon)({
  position: "absolute",
  right: "5px",
  top: "5px",
  height: "22px",
  zIndex: 2,
});

const SearchInput = (props: SearchInputProps): JSX.Element => {
  const [value, setValue] = useState("")
  const onValueChange = (value: string) => {
    setValue(value)
    props.onSearchChange(value);
  };

  return (
    <SearchBox>
      <SearchBoxInput
        id={props.placeHolder.split(" ").join("-")}
        placeholder={props.placeHolder}
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          onValueChange(e.currentTarget.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            props.onSearch();
          }
        }}
        value={value}
      />
      <SearchBoxIcon
        onClick={() => {
          props.onSearch();
        }}
      />
      {props.onCancel ? (
        <CancelIcon
          onClick={() => {
            onValueChange("")
            props.onCancel()
          }}
        />
      ) : null}
    </SearchBox>
  );
};

export default SearchInput;
